import { ApiProperty } from "@nestjs/swagger";

export class LocationRequest{
    @ApiProperty()
    locationId:number;
    @ApiProperty()
    plantId:number;
}